import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function getScholarshipState(startDateUtc: Date, endDateUtc: Date) {
  const currentDateUTC = dayjs.utc();
  const startDateUTC = dayjs(startDateUtc);
  const endDateUTC = dayjs(endDateUtc);
  // Note: if current date is before the start date => "inactive"
  if (currentDateUTC.isBefore(startDateUTC)) return 'inactive';
  // Note: if current date is before the end date => "active"
  else if (currentDateUTC.isBefore(endDateUTC)) return 'active';
  // Note: otherwise, it is expired
  else return 'expired';
}
